"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _colors = require("HubStyleTokens/colors");

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _EditLinkPopoverPreview = _interopRequireDefault(require("./EditLinkPopoverPreview"));

var _LinkPopoverControls = _interopRequireDefault(require("./LinkPopoverControls"));

var _withLinkState = _interopRequireDefault(require("./withLinkState"));

var _popover = require("../../constants/popover");

var _iterables = require("../../utils/iterables");

/**
 * @TODO Remove this once `useContextualToolbar` is fully ungated
 */
var EditLinkPopoverBody = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditLinkPopoverBody, _Component);

  function EditLinkPopoverBody() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, EditLinkPopoverBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(EditLinkPopoverBody)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleCloseOnKeyDown = function (evt) {
      if (evt.key === _popover.KeyTypes.ESCAPE) {
        _this.props.onClose();
      }
    };

    _this.handleEditClick = function () {
      _this.props.onModeChange(_popover.PopoverBodyMode.EDIT);
    };

    return _this;
  }

  (0, _createClass2.default)(EditLinkPopoverBody, [{
    key: "renderPreview",
    value: function renderPreview() {
      var previewProps = (0, _iterables.pick)(Object.keys(_EditLinkPopoverPreview.default.propTypes), this.props);
      return _react.default.createElement(_EditLinkPopoverPreview.default, Object.assign({}, previewProps, {
        onEdit: this.handleEditClick
      }));
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      var controlProps = (0, _iterables.pick)(Object.keys(_LinkPopoverControls.default.propTypes), this.props);
      return _react.default.createElement("div", {
        className: "link-popover-edit"
      }, !this.props.useExplicitSave && _react.default.createElement(_UICloseButton.default, {
        onClick: this.props.onClose,
        color: _colors.EERIE,
        className: "hs-close-button"
      }), _react.default.createElement(_LinkPopoverControls.default, Object.assign({}, controlProps, {
        popoverType: _popover.PopoverType.EDIT,
        onSubmit: this.props.onSave
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "p-x-5 p-y-3 hs-link-popover-edit",
        onKeyDown: this.handleCloseOnKeyDown,
        tabIndex: "-1"
      }, _react.default.createElement(_reactTransitionGroup.CSSTransitionGroup, {
        className: "link-transition",
        transitionName: "link-edit",
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, this.props.mode === _popover.PopoverBodyMode.PREVIEW ? _react.default.createElement("div", {
        key: 0
      }, this.renderPreview()) : _react.default.createElement("div", {
        key: 1
      }, this.renderEdit())));
    }
  }]);
  return EditLinkPopoverBody;
}(_react.Component);

EditLinkPopoverBody.propTypes = Object.assign({
  onSave: _propTypes.default.func,
  mode: _propTypes.default.oneOf([_popover.PopoverBodyMode.PREVIEW, _popover.PopoverBodyMode.EDIT]),
  onModeChange: _propTypes.default.func.isRequired
}, (0, _iterables.omit)(['onEdit'], _EditLinkPopoverPreview.default.propTypes), {}, (0, _iterables.omit)(['popoverType, onSubmit'], _LinkPopoverControls.default.propTypes));

var _default = (0, _withLinkState.default)(EditLinkPopoverBody);

exports.default = _default;
module.exports = exports.default;